module.exports = __webpack_public_path__ + "img/icon_t14.6d765ce3.png";